<n-card-panel class="copy-from-dataTurbo">
    <div slot="title" class="copy-from-switch">
        <h2 class="card-title">{{i18n.title.dataTurbo}}</h2>
        <n-switch id="copy-from-dataTurbo" [(ngModel)]="switch" (onChange)="onSwitchChange($event)">
        </n-switch>
    </div>

    <form *ngIf="switch" [errorMessage]="errorMessage" [formGroup]="vm" class="common-form">
        <!-- 创建模式 -->
        <n-form-item [label]="i18n.label.createStyle" [required]="true" class="create-style">
            <n-radio-group id="copy-from-data-turbo-share_style" [block]="true" formControlName="DataTurbocreateStyle"
                (onChange)="onCreateStyleChange($event)">
                <!-- copy from -->
                <n-radio
                    id="copy-from-data-turbo-share_copyFrom"
                    [value]="CreateStyleE.CopyFrom"
                    [disabled]="isAuditLogFs">
                    <div class="copy-from-select">
                        <span>{{i18n.label.copyFrom}}</span>
                        <div>
                            <!-- 用hideen的原因，是切换的时候ngif会导致选中项丢失,且无法获取到shareSelect -->
                            <n-select [class.hidden]="vm.value.DataTurbocreateStyle !== CreateStyleE.CopyFrom"
                                [(ngModel)]="copyFromSelection" #DataTurboshareSelect id="copy-from-data-turbo-share_copyFrom_drop"
                                [rest]="shareRest" [valueField]="'ID'" formControlName="DataTurbocopyFromSelect"
                                [labelField]="'sharePath'" [filter]="true" (onChange)="onCopyShareChange($event)">
                            </n-select>
                        </div>
                    </div>
                </n-radio>
                <!-- new -->
                <n-radio id="copy-from-data-turbo-share_new" [value]="CreateStyleE.New">
                    {{i18n.label.new}}
                </n-radio>
            </n-radio-group>
        </n-form-item>

        <!-- 共享 -->
        <n-form-item [label]="i18n.label.share">
            <div class="n-form-item-text">
                <!-- 共享名称 -->
                <!-- vm.value.DataTurbocreateStyle是指 new 和 copy from，createShare下指定了这两个变量 -->
                <span nTextTips
                    class="share-path">{{createShare[vm.value.DataTurbocreateStyle].share.sharePath || UNPLACEHOLDER}}</span>
                <!-- 逗号 -->
                <span>{{i18n.label.comma}}</span>
                <!-- 权限数-->
                <span>{{permissionsNumStr}}</span>
                <!-- modify 按钮 -->
                <!-- 租户没选的时候，new提示选租户， copyfrom提示选择共享就可以了，因为共享本身依赖租户 -->
                <button nButton [theme]="'text'" class="copy-from-btn" (click)="modifyShare()"
                    [disabled]="(!selectShareOpt && vm.value.DataTurbocreateStyle === CreateStyleE.CopyFrom) || !this.vstoreId"
                    [disabledTips]="vm.value.DataTurbocreateStyle === CreateStyleE.CopyFrom ? i18n.tip.plsSlectShare : i18n.tip.plsSelectVstore"
                    [loading]="$getCount">{{i18n.btn.modifyBtn}}
                </button>
            </div>
        </n-form-item>
    </form>
</n-card-panel>
